import React, { Component } from 'react';
import { connect } from 'react-redux';
import ChoiceWidget from "../ChoiceWidget";
import {SimpleColorPicker} from "../ColorPicker";
// import AlphaSelector from "../AlphaSelector";
import { toggleLoading, addNewTemplateText, updateTemplateText, addNewTemplateImage, updateTemplateImage, editObject, editFont, addNewTemplate, deleteTemplateObject } from "../../actions";
// import {Button, ButtonGroup} from "reactstrap";
import Uppy from "@uppy/core";
import XHRUpload from "@uppy/xhr-upload";
import {DragDrop} from "@uppy/react";
import uuidv4 from "uuid/v4";

class TemplateTextPane extends Component {

  state = {}

  constructor(props) {
    super(props);
    this.updateTemplateFont = this.updateTemplateFont.bind(this);
    this.changeTemplateColor = this.changeTemplateColor.bind(this);
    this.changeText = this.changeText.bind(this);
    this.changeAlignHOC = this.changeAlignHOC.bind(this);
    this.changeScale = this.changeScale.bind(this);
    this.state = Object.assign({}, this.props.item.props);
    this.state.currentFont = this.props.fonts.fonts[0];
  }

  changeText(e) {

    if (this.props.canvas.templateObjects[this.props.item.id]) {
      const uuid = this.props.canvas.templateObjects[this.props.item.id];
      // Update object
      this.props.editObject(uuid, {
        text: e.target.value
      });
    } else {
      // New object
      const uuid = uuidv4();

      const currentSurface = this.props.objects.present.currentSurface;
      const surfaceId = this.props.objects.present.currentSurface.surface.id;
      const canvas = currentSurface.surface.canvas;

      this.props.addNewTemplateText(this.props.item.id, uuid, {
        ...this.state,
        text: e.target.value,
        x: this.props.item.x * canvas.width,
        y: this.props.item.y * canvas.height,
        //width: this.props.item.width * canvas.width,
        //height: this.props.item.height * canvas.height
      });
    }
    //this.props.updateTemplateObject(this.props.index, {text: e.target.value});
  }

  updateTemplateFont(font) {
    this.setState({
      currentFont: font,
      fontFamily: font.value
    });

    if (this.props.canvas.templateObjects[this.props.item.id]) {
      const uuid = this.props.canvas.templateObjects[this.props.item.id];
      this.props.editFont(uuid, {fontFamily: font.value}, font);
    }
    // this.props.updateTemplateText(this.props.item.id, {fontFamily: font.value});
  }

  changeTemplateColor(fill) {
    this.setState({
      fill: fill.hex
    });
    if (this.props.canvas.templateObjects[this.props.item.id]) {
      const uuid = this.props.canvas.templateObjects[this.props.item.id];
      this.props.editObject(uuid, { fill: fill.hex });
    }
    // this.props.updateTemplateText(this.props.id, {fill: fill.hex});
  }

  changeAlignHOC(align) {
    return () => {
      this.setState({
        align: align
      });

      if (this.props.canvas.templateObjects[this.props.item.id]) {
        const uuid = this.props.canvas.templateObjects[this.props.item.id];
        this.props.editObject(uuid, { align });
      }
      // this.props.updateTemplateText(this.props.id, {align});
    };
  }

  changeScale(e) {
    if (this.props.canvas.templateObjects[this.props.item.id]) {
      const uuid = this.props.canvas.templateObjects[this.props.item.id];
      const surfaceId = this.props.objects.present.currentSurface.surface.id;
      const object = this.props.objects.present.objects[surfaceId][this.props.canvas.templateObjects[this.props.item.id]];
      const computedScale = e.target.value / object.props.fontSize;
      this.props.editObject(uuid, {scaleX: computedScale, scaleY: computedScale});
    }
  }

  render() {
    let value = '';
    let computedSize = '';
    if (this.props.canvas.templateObjects[this.props.item.id]) {
      const surfaceId = this.props.objects.present.currentSurface.surface.id;
      const object = this.props.objects.present.objects[surfaceId][this.props.canvas.templateObjects[this.props.item.id]];
      value = object.props.text;
      computedSize = Math.round(object.props.fontSize * (object.props.scaleY || 1));
    }

    return (
      <div className="t-container-sidebar-content t-container-border-bottom">
        <h3><span className="t-container-sidebar-number" style={{backgroundColor: this.props.item.color}}>{this.props.index + 1}</span> {this.props.item.name}</h3>

        <textarea ref={this.textAreaRef} className="form-control" value={value} onChange={this.changeText} rows={(this.props.item.rows || 4)} placeholder="テキストを入力してください"/>
        <ChoiceWidget
          choices={this.props.fonts.fonts}
          data={this.state.currentFont}
          onSelect={this.updateTemplateFont}
          groupBy="lang"
          renderLabel={(value) => {
            return <span style={{fontFamily: value.value}}>{value.label}</span>;
          }}
          renderChoice={(value) => {
            return <span style={{fontFamily: value.value}}>{value.label}</span>;
          }}
          renderHeader={(key) => {

            return <span>{this.props.fonts.languages[key]}</span>;
          }}
        />

        <div className="t-container-sidebar-template-text-flex">
          <button className={"btn-icon btn-icon-only " + (this.state.align === 'left' ? 'active': '')} onClick={this.changeAlignHOC('left')} data-tip="左寄せ">
            <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-align-left.png"} alt="" width={12} />
          </button>
          <button className={"btn-icon btn-icon-only " + (this.state.align === 'center' ? 'active': '')} onClick={this.changeAlignHOC('center')} data-tip="中央寄せ">
            <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-align-h-center.png"} alt="" width={12} />
          </button>
          <button className={"btn-icon btn-icon-only " + (this.state.align === 'right' ? 'active': '')} onClick={this.changeAlignHOC('right')} data-tip="右寄せ">
            <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-align-right.png"} alt="" width={12} />
          </button>
          <SimpleColorPicker value={this.state.fill} name={"cp-" + this.props.index} onChange={this.changeTemplateColor} iconOnly/>
          <div className="t-font-size-input">
            <input type="number" className="form-control" value={computedSize} onChange={this.changeScale} disabled={!computedSize}/>
          </div>
        </div>


      </div>
    );
  }
}

TemplateTextPane = connect(f => f, {addNewTemplateText, updateTemplateText, editObject, editFont})(TemplateTextPane);

class TemplateImagePane extends Component {
  state = {
    src: null
  }

  constructor(props) {
    super(props);
    this.updateImage = this.updateImage.bind(this);
  }

  componentWillMount() {
    this.uppy = new Uppy({
      restrictions: {  },
      autoProceed: true
    });

    this.uppy.use(XHRUpload, {
      endpoint: window.tProjectGlobals.baseUrl + '/designer/upload',
      method: 'post',
      formData: true,
      fieldName: 'files'
    });

    this.uppy.on('upload', () => {
      this.props.toggleLoading(true);
    })

    this.uppy.on('upload-success', (file, {body}) => {
      this.updateImage(body);
    });
  }

  updateImage(res) {
    const currentSurface = this.props.objects.present.currentSurface;
    const canvas = currentSurface.surface.canvas;
    const height = canvas.height * this.props.item.height;

    const props = {
      src: res.url,
      width: res.width,
      height: res.height,
      scaleX: height / res.height,
      scaleY: height / res.height,
      x: this.props.item.x * canvas.width,
      y: this.props.item.y * canvas.height,
    };

    if (this.props.canvas.templateObjects[this.props.item.id]) {
      //this.props.updateTemplateImage(this.props.item.id, props);
      const uuid = this.props.canvas.templateObjects[this.props.item.id];
      this.props.deleteTemplateObject(uuid);
    }

    const uuid = uuidv4();
    this.props.addNewTemplateImage(this.props.item.id, uuid, props, this.props.item.name);
    // this.props.updateTemplateObject(this.props.index, {
    //   src: res.url,
    //   width: res.width,
    //   height: res.height,
    //   scaleX: height / res.height,
    //   scaleY: height / res.height,
    // });
    this.props.toggleLoading(false);
    this.setState({src: res.url});
  }

  render() {
    return (
      <div className="t-container-sidebar-content t-container-border-bottom">
        <h3><span className="t-container-sidebar-number" style={{backgroundColor: this.props.item.color}}>{this.props.index + 1}</span> {this.props.item.name}</h3>

        <div
          className="t-container-sticker-cell"
          style={{backgroundImage: 'url(' + this.state.src + ')'}}
        />
        <div className="t-container-sidebar-uppy">
          <div className="t-container-sidebar-uppy-inside">
            <DragDrop uppy={this.uppy} note="対応形式: JPEG, PNG, GIF, AI, PSD, SVG" locale={{
              strings: {
                dropHereOr: '画面に画像をドロップするか、%{browse}してください。',
                // Used as the label for the link that opens the system file selection dialog.
                browse: 'ファイルから選択'
              }
            }} />
          </div>
        </div>
      </div>
    );
  }
}

TemplateImagePane = connect(f => f, {addNewTemplateImage, updateTemplateImage, toggleLoading, editObject, deleteTemplateObject})(TemplateImagePane);

class TemplatePane extends Component {

  constructor(props) {
    super(props);
    this.handleNewText = this.handleNewText.bind(this);
    this.handleNewImage = this.handleNewImage.bind(this);
  }

  handleNewText() {
    this.props.addNewTemplate({
      id: 'company', name: '追加テキスト', x: 0.02, y: 0.155, width: 0.96, height: 0.13, type: 'text', color: '#8a2f05', props: {
        text: '',
        fontFamily: 'sourcehansansr',
        fill: '#000000',
        verticalAlign: 'middle',
        align: 'left',
        fontSize: 16
      }
    });
  }

  handleNewImage() {
    //
  }

  render() {
    return (
      <div className="t-container-sidebar-pane t-container-sidebar-pane-bottom">
        {this.props.canvas.template.map((item, i) => {
          switch (item.type) {
            case 'text':
              return <TemplateTextPane key={i} item={item} index={i} />;
            case 'image':
              return <TemplateImagePane key={i} item={item} index={i} />;
          }
        })}

        {/*<div className="t-container-sidebar-content">*/}
        {/*  <button onClick={this.handleNewText} className="btn btn-info btn-block"><i className="fa fa-plus"/> テキストを追加する</button>*/}
        {/*  <button onClick={this.handleNewImage} className="btn btn-info btn-block"><i className="fa fa-plus"/> 画像を追加する</button>*/}
        {/*</div>*/}

      </div>
    );
  }

}

export default connect(f => f, {addNewTemplate})(TemplatePane);


// WEBPACK FOOTER //
// ./src/components/Sidebar/TemplatePane.js